import React from "react";
import { useTranslation } from "react-i18next";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../types";
import ToggleSection from "./ToggleSection";

interface StandaloneSectionProps extends WizardStepProps<ActivityWizardData> {
  locked?: boolean;
}

const StandaloneSection: React.FC<StandaloneSectionProps> = ({
  data,
  setData,
  locked = false,
}) => {
  const { t } = useTranslation("wizard-activity");
  return (
    <ToggleSection
      question={t("sections.standalone.question")}
      description={t("sections.standalone.description") || undefined}
      checked={data.is_standalone}
      onChange={(next) => setData({ is_standalone: next })}
      noLabel={t("common.no") || "No"}
      yesLabel={t("common.yes") || "Sì"}
      disabled={locked}
    />
  );
};

export default StandaloneSection;
